Directives.AccountSetupDisabled = function AccountSetupDisabled() {

    "use strict";
    
    // @ngInject
    function AccountSetupDisabledControllerCtor($scope, $injector, $translate, AppStates, AnalyticsService) {
        this.constructor.$super.call(this, $scope, $injector);
        this._objectType = 'AccountSetupDisabledController';
        this.$translate = $translate;
        this.AppStates = AppStates;
        this.AnalyticsService = AnalyticsService;

        this.faqData = [
            {
                id: 1,
                question: 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._QUESTION_',
                answer: "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_TEXT_1_') + "</p>" 
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_TEXT_2_') + "</p>" 
                        + "<ol><li>" + this.$translate.instant( 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_LIST_1_') + "</li>"
                        + "<li>" + this.$translate.instant( 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_LIST_2_') + "</li>"
                        + "<li>" + this.$translate.instant( 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_LIST_3_') + "</li></ol>" 
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_1._ANSWER_TEXT_3_') + "</p>",
                isOpen: false,
            },
            {
                id: 2,
                question: 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._QUESTION_',
                answer: "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._ANSWER_TEXT_1_') + "</p>" 
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._ANSWER_TEXT_2_') + "</p>" 

                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._ANSWER_TEXT_3_') + "</p>"
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._ANSWER_TEXT_4_') + "</p>" 
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_2._ANSWER_TEXT_5_') + "</p>",
                isOpen: false,
            },
            {
                id: 3,
                question: 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_3._QUESTION_',
                answer: "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_3._ANSWER_TEXT_1_') + "</p>",
                isOpen: false,
            },
            {
                id: 4,
                question: 'COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_4._QUESTION_',
                answer: "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_4._ANSWER_TEXT_1_') + "</p>"
                        + "<p>" + this.$translate.instant('COMPANY_SETTING.SETUP.DISABLED.FAQS.FAQ_4._ANSWER_TEXT_2_') + "</p>",
                isOpen: false,
            },
        ];

    }

    var AccountSetupDisabledController = Class(Controllers.BaseController, {
        constructor: AccountSetupDisabledControllerCtor,

        toggleAccordion: function toggleAccordion(clickedFaqId) {
            this.faqData.map((faq)=>{
                if(faq.id === clickedFaqId && faq.isOpen) {
                    return faq.isOpen = false;
                } else {
                    return faq.isOpen = (faq.id === clickedFaqId);
                }
            });
        },

    });

    return {
        scope: {},
        templateUrl: 'angular/app/modules/core/features/account_setup/account_setup_disabled_template.html',
        controller: AccountSetupDisabledController,
        controllerAs: 'accountSetupDisabledVm',
        bindToController: true
    };
};